<template>
  <ul class="c-list--checkup">
    <li class="c-list--checkup__item">
      <span class="c-list--checkup__label judgement">判定</span>
      <div class="c-list--checkup__content">
        <p v-if="!hasError">
          あなたのWebページはFlashが使用されていません。
        </p>
        <p v-else>
          あなたのWebページはFlashが使用されています。
        </p>
      </div>
    </li>
    <li v-if="useFlashUrls.length" class="c-list--checkup__item">
      <span class="c-list--checkup__label detail">内容</span>
      <div class="c-list--checkup__content">
        <dl>
          <dt>使用されている内容</dt>
          <dd>
            <ul class="c-list--disc">
              <li v-for="(item, index) in useFlashUrls" :key="index">
                {{ item }}
              </li>
            </ul>
          </dd>
        </dl>
      </div>
    </li>
    <li v-if="hasError" class="c-list--checkup__item">
      <span class="c-list--checkup__label hint">ヒント</span>
      <div class="c-list--checkup__content">
        <p>
          HTML5
          CanvasとCSS3を使用すると、多くの複雑なFlashアニメーション、描画、およびインタラクティブ機能を置き換えることができます。これらをJavaScriptと組み合わせて、ActionScriptを置き換えるより複雑なインタラクティブ機能を作成できます。
        </p>
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    detail: {
      type: Object,
      required: true
    },
    hasError: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    useFlashUrls() {
      if (this.detail.urls) {
        return this.detail.urls.filter(item => item);
      }
      return [];
    }
  }
};
</script>
